import React, { memo } from 'react';
import './LoadingSpinner.css';

const LoadingSpinner = memo(() => {
  return (
    <div className="loading-overlay">
      <div className="loading-spinner">
        <img 
          src="./images/logo2.png" 
          alt="Loading..." 
          className="loading-logo"
          onLoad={() => console.log('Loading logo loaded')}
          onError={() => console.warn('Loading logo failed to load')}
        />
        <div className="loading-text">Loading...</div>
      </div>
    </div>
  );
});

LoadingSpinner.displayName = 'LoadingSpinner';

export default LoadingSpinner;